import { useFormContext } from "react-hook-form";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import NumberField from "../../../Form/NumberField";
import TextField from "../../../Form/TextField";
import {
  CAP,
  CAP_FREQUENCY_EXPLANATION,
  DAYS,
  FREQUENCY_CAP_EXPLANATION,
  FREQUENCY_TARGET_EXPLANATION,
  TARGET,
  TARGET_FREQUENCY_EXPLANATION,
  TIMES_EVERY,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import { Controller } from "react-hook-form";
import { getReactHookFormNestedError } from "../../../../utils/errors";

const BTReservedFrequencyControlMeta = ({
  name,
  control,
  disabled = false,
}) => {
  const {
    watch,
    formState: { errors },
  } = useFormContext();

  const frequencyData = watch(name) || { type: "", value: "", interval: "" };
  const { type = "cap", value, interval } = frequencyData;

  const { t } = useTranslationApp();
  const errorType = getReactHookFormNestedError(errors, `${name}.type`);

  return (
    <Box>
      {/* Frequency Type Selection */}
      <Controller
        name={`${name}.type`}
        control={control}
        defaultValue="cap"
        render={({ field }) => (
          <RadioGroup
            {...field}
            column
            disabled={disabled}
            sx={{ gap: 1, mb: 2 }}
            error={!!errorType}
          >
            {errorType && (
              <Typography variant="body2" color="error">
                {errorType.message}
              </Typography>
            )}
            <Box>
              <FormControlLabel
                value="target"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {t(TARGET)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {t(TARGET_FREQUENCY_EXPLANATION)}
                    </Typography>
                  </Box>
                }
              />
            </Box>
            <Box>
              <FormControlLabel
                value="cap"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {t(CAP)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {t(CAP_FREQUENCY_EXPLANATION)}
                    </Typography>
                  </Box>
                }
              />
            </Box>
          </RadioGroup>
        )}
      />

      {/* Frequency Values */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box>
          <TextField
            name={`${name}.value`}
            disabled={disabled}
            fullWidth
            variant="filled"
            InputProps={{
              inputComponent: NumberField,
            }}
            control={control}
            errors={errors}
          />
        </Box>
        <Box>
          <Typography variant="body2">{t(TIMES_EVERY)}</Typography>
        </Box>
        <Box>
          <TextField
            name={`${name}.interval`}
            disabled={disabled}
            fullWidth
            variant="filled"
            InputProps={{
              inputComponent: NumberField,
            }}
            control={control}
            errors={errors}
          />
        </Box>
        <Box>
          <Typography variant="body2">{t(DAYS)}</Typography>
        </Box>
      </Box>

      {/* Description Text */}
      {value && interval && (
        <Typography
          variant="caption"
          color="fields.placeholder"
          sx={{
            mt: 0.5,
          }}
        >
          {t(
            type === "cap"
              ? FREQUENCY_CAP_EXPLANATION
              : FREQUENCY_TARGET_EXPLANATION,
            {
              value: value || 0,
              interval: interval || 0,
            }
          )}
        </Typography>
      )}
    </Box>
  );
};

export default BTReservedFrequencyControlMeta;
